import { useTranslation } from 'react-i18next';

const DICT = {
  it: {
    title: 'Coach AI', subtitle: 'Straight Line + 10X: valuta la call, scrive note, step e testi',
    tabAnalyze: 'Analizza call', tabHistory: 'Valutazioni', tabWrite: 'Scrivi con il Coach',
    pasteLabel: 'Incolla la trascrizione della call', pastePh: 'Agente: … / Cliente: … (anche senza nomi va bene)',
    analyzeBtn: 'Analizza la call', orUpload: 'oppure carica la registrazione',
    uploadHint: 'Audio o video (mp3, m4a, wav, mp4, mov…). Consiglio: da Zoom carica solo il file audio .m4a.',
    chooseFile: 'Scegli file', uploading: 'Caricamento', minChars: 'Servono almeno 200 caratteri di trascrizione',
    transcribing: 'Trascrivo la registrazione…', analyzing: 'Il Coach sta valutando la call…',
    working: 'Ci vuole circa 1 minuto: puoi restare qui o tornare più tardi.',
    error: 'Errore', retry: 'Riprova analisi', open: 'Apri', noCalls: 'Nessuna call analizzata per questo cliente.',
    score: 'Voto call', summary: 'Riassunto (va nelle note)', steps: 'Prossimi step (vanno nella scheda)',
    addStep: 'Aggiungi step', strengths: 'Cosa hai fatto bene', improvements: 'Cosa migliorare',
    objections: 'Obiezioni', better: 'Risposta migliore', handled: 'Come l’hai gestita',
    straightLine: 'Straight Line (0-10)', belfort: 'Consiglio Belfort', cardone: 'Consiglio Cardone',
    followup: 'WhatsApp di follow-up pronto', copy: 'Copia', copied: 'Copiato',
    save: 'Salva nella scheda', saved: 'Salvato: riassunto nelle note e step nella scheda',
    applied: 'Già salvato nella scheda', close: 'Chiudi', hiddenEval: 'Valutazione visibile solo a chi ha fatto la call e all’admin',
    snapshot: 'Profilo cliente emerso', delete: 'Elimina',
    nextStepsTitle: 'Prossimi step', nextStepsEmpty: 'Nessuno step: analizza una call con il Coach o aggiungine uno.',
    stepPh: 'Nuovo step…', chatPh: 'Chiedi al Coach: un’email, un WhatsApp, come rispondere a un’obiezione…',
    send: 'Invia', newChat: 'Nuova chat', coachThinking: 'Il Coach scrive…',
    chips: ['Email di follow-up dopo la call', 'WhatsApp breve per fissare il prossimo appuntamento',
      'Come rispondo a “è troppo caro”?', 'Script per richiamarlo domani', 'Messaggio per coinvolgere il partner nella decisione'],
  },
  es: {
    title: 'Coach IA', subtitle: 'Straight Line + 10X: evalúa la llamada, escribe notas, pasos y textos',
    tabAnalyze: 'Analizar llamada', tabHistory: 'Evaluaciones', tabWrite: 'Escribir con el Coach',
    pasteLabel: 'Pega la transcripción de la llamada', pastePh: 'Agente: … / Cliente: …',
    analyzeBtn: 'Analizar la llamada', orUpload: 'o sube la grabación',
    uploadHint: 'Audio o vídeo (mp3, m4a, wav, mp4, mov…). Consejo: de Zoom sube solo el audio .m4a.',
    chooseFile: 'Elegir archivo', uploading: 'Subiendo', minChars: 'Se necesitan al menos 200 caracteres',
    transcribing: 'Transcribiendo la grabación…', analyzing: 'El Coach está evaluando la llamada…',
    working: 'Tarda alrededor de 1 minuto: puedes quedarte o volver más tarde.',
    error: 'Error', retry: 'Reintentar análisis', open: 'Abrir', noCalls: 'Ninguna llamada analizada para este cliente.',
    score: 'Nota llamada', summary: 'Resumen (va a las notas)', steps: 'Próximos pasos (van a la ficha)',
    addStep: 'Añadir paso', strengths: 'Lo que hiciste bien', improvements: 'Qué mejorar',
    objections: 'Objeciones', better: 'Mejor respuesta', handled: 'Cómo la gestionaste',
    straightLine: 'Straight Line (0-10)', belfort: 'Consejo Belfort', cardone: 'Consejo Cardone',
    followup: 'WhatsApp de seguimiento listo', copy: 'Copiar', copied: 'Copiado',
    save: 'Guardar en la ficha', saved: 'Guardado: resumen en notas y pasos en la ficha',
    applied: 'Ya guardado en la ficha', close: 'Cerrar', hiddenEval: 'Evaluación visible solo para quien hizo la llamada y el admin',
    snapshot: 'Perfil del cliente', delete: 'Eliminar',
    nextStepsTitle: 'Próximos pasos', nextStepsEmpty: 'Ningún paso: analiza una llamada o añade uno.',
    stepPh: 'Nuevo paso…', chatPh: 'Pide al Coach: un email, un WhatsApp, cómo responder a una objeción…',
    send: 'Enviar', newChat: 'Nuevo chat', coachThinking: 'El Coach escribe…',
    chips: ['Email de seguimiento tras la llamada', 'WhatsApp corto para fijar la próxima cita',
      '¿Cómo respondo a “es demasiado caro”?', 'Guion para volver a llamarle mañana', 'Mensaje para implicar a la pareja en la decisión'],
  },
};
DICT.en = DICT.it;

export function useCoachT() {
  const { i18n } = useTranslation();
  const lang = (i18n.language || 'it').slice(0, 2);
  const d = DICT[lang] || DICT.it;
  return { t: (k) => d[k] ?? DICT.it[k] ?? k, lang: DICT[lang] ? lang : 'it' };
}
